import React from 'react';

function About() {
  return (
    <div className="container mx-auto py-20 px-4">
      <h1 className="text-4xl font-bold text-indigo-700 mb-6">About Us</h1>
      <p className="text-lg text-gray-700 leading-relaxed">
        Welcome to GetAHomePrice.com! We are dedicated to providing the best service to our customers. 
        Our mission is to offer competitive offers for your home while making the process as seamless as possible.
      </p>
    </div>
  );
}

export default About;

